export default __webpack_public_path__ + "static/summer_containers28-159e63647ae4db47d8b13e487708c817.webp";